var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menuItemHeadMobileMenu" }, [
    _c("div", { staticClass: "menuItemTitleMobileMenu" }, [
      _vm.labelId && _vm.labelId !== ""
        ? _c("span", [_vm._v(_vm._s(_vm.$t(_vm.labelId)))])
        : _c("span", [_vm._v(_vm._s(_vm.label))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "menuItemSubBarMobileMenu" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }